import { render, staticRenderFns } from "./Pledge.vue?vue&type=template&id=736fb687&scoped=true&"
import script from "./Pledge.vue?vue&type=script&lang=js&"
export * from "./Pledge.vue?vue&type=script&lang=js&"
import style0 from "./Pledge.vue?vue&type=style&index=0&id=736fb687&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736fb687",
  null
  
)

export default component.exports